module.exports = __webpack_public_path__ + "img/Group 2.a8f538f9.svg";